import React, { useEffect, useState } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CloudDownloadOutlinedIcon from "@material-ui/icons/CloudDownloadOutlined";
import TouchAppOutlinedIcon from "@material-ui/icons/TouchAppOutlined";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import CustomFilterHeader from "./CustomFilterHeader";

function StaticCustomSideBar({ children, sliderCollapsed }) {
  const data = JSON?.parse(localStorage.getItem("cmpy_info")) || {};

  const handleManualSyncClick = () => {};

  const handleMarketplaceChange = () => {};

  return (
    <>
      <Helmet>
        <title>{"Forcesight"}</title>
      </Helmet>
      <div>
        <CustomFilterHeader
          headerTitle="Loading..."
          handleManualSyncClick={handleManualSyncClick}
          handleMarketplaceChange={handleMarketplaceChange}
          showManualSync={false}
          searchFunction={(ds, searchText) => {}}
          rows={[]}
          showDateRanges={false}
          searchHide={false}
          showExportButton={false}
          showSearchBar={true}
          columns={[]}
          isLoading={true}
          onFilterUpdate={(data) => {}}
          exportFileName=""
          onSearchTextEntered={() => {}}
        />
        <div className="mainWrapper">
          <Sidebar
            backgroundColor="#2B3990"
            collapsed={sliderCollapsed}
            className="fixed h-screen"
          >
            <Menu style={{ paddingTop: "30px" }}>
              <Menu
                menuItemStyles={{
                  button: {
                    // the active class will be added automatically by react router
                    // so we can use it to style the active menu item
                    [`&.active`]: {
                      backgroundColor: "#13395e",
                      color: "#fff",
                    },
                  },
                }}
              >
                <MenuItem
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  }
                  component={<Link to="/exception-rules" />}
                >
                  Action Required
                </MenuItem>
                <SubMenu
                  title="Optimize Profits"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"
                      />
                    </svg>
                  }
                  label="Optimize Profits"
                  component={<Link to="/profitability/0" />}
                  open={true}
                >
                  <MenuItem component={<Link to="/profitability/2" />}>
                    Profit Table
                  </MenuItem>
                  {/* <MenuItem component={<Link to="/action-required" />}>
                    Action Required
                  </MenuItem> */}
                  <SubMenu title="Alternate View" label="Alternate View">
                    <MenuItem component={<Link to="/price-tracker/1" />}>
                      Pricing
                    </MenuItem>
                    <MenuItem component={<Link to="/price-tracker/3" />}>
                      Price Compliance
                    </MenuItem>
                    <MenuItem component={<Link to="/price-tracker/2" />}>
                      Discount Compliance
                    </MenuItem>
                    <MenuItem component={<Link to="/sales-defence/1" />}>
                      Buybox
                    </MenuItem>
                    <MenuItem component={<Link to="/return-insights/2" />}>
                      Orders
                    </MenuItem>
                    <MenuItem component={<Link to="/return-insights/0" />}>
                      Returns
                    </MenuItem>
                  </SubMenu>
                </SubMenu>
                <SubMenu
                  title="Optimize Cash"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"
                      />
                    </svg>
                  }
                  label="Optimize Cash"
                  component={<Link to="/optimize-cash" />}
                >
                  <SubMenu
                    title="Payments"
                    label="Payments"
                    component={<Link to="/payment-tracker/0" />}
                  >
                    <MenuItem component={<Link to="/payment-tracker/1" />}>
                      Settled Orders
                    </MenuItem>
                    <MenuItem component={<Link to="/payment-tracker/2" />}>
                      Unsettled Orders
                    </MenuItem>
                    <MenuItem component={<Link to="/payment-tracker/3" />}>
                      {" Bank View (Beta)"}
                    </MenuItem>
                  </SubMenu>

                  <SubMenu
                    title="Inventory"
                    label="Inventory"
                    component={<Link to="/inventory/0" />}
                  >
                    <MenuItem component={<Link to="/inventory/2" />}>
                      Ledger
                    </MenuItem>
                    <MenuItem component={<Link to="/inventory/3" />}>
                      Restock
                    </MenuItem>
                    <MenuItem component={<Link to="/inventory/1" />}>
                      Performance
                    </MenuItem>
                  </SubMenu>
                </SubMenu>
                <SubMenu
                  title="Brand Intelligence"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
                      />
                    </svg>
                  }
                  label="Brand Intelligence"
                  component={<Link to="/reviews/0" />}
                >
                  <MenuItem component={<Link to="/reviews/1" />}>
                    Product View
                  </MenuItem>
                  <MenuItem component={<Link to="/reviews/3" />}>
                    Review Analyser
                  </MenuItem>
                  <MenuItem component={<Link to="/reviews/4" />}>
                    Campaign
                  </MenuItem>
                  <MenuItem component={<Link to="/reviews/5" />}>
                    Seller Reviews
                  </MenuItem>
                </SubMenu>
                <SubMenu
                  title="Product Intelligence"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      data-slot="icon"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z"
                      />
                    </svg>
                  }
                  label="Product Intelligence"
                >
                  <SubMenu
                    title="Keyword"
                    label="Keyword"
                    component={<Link to="/keywords-tracker/0" />}
                  >
                    <MenuItem component={<Link to="/keywords-tracker/1" />}>
                      Identify Products
                    </MenuItem>
                    <MenuItem component={<Link to="/keywords-tracker/2" />}>
                      Track Product Performance
                    </MenuItem>
                    <MenuItem component={<Link to="/keywords-tracker/3" />}>
                      Url Rotator
                    </MenuItem>
                  </SubMenu>
                </SubMenu>
                <SubMenu
                  title="Product Settings"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  }
                  label="Product Settings"
                >
                  <MenuItem component={<Link to="/master-sku/0" />}>
                    Configure Product
                  </MenuItem>
                  <MenuItem component={<Link to="/master-sku/1" />}>
                    Configure Pincode
                  </MenuItem>
                  <MenuItem component={<Link to="/master-sku/2" />}>
                    Configure DIO
                  </MenuItem>
                  <MenuItem component={<Link to="/cashback" />}>
                    Cashback
                  </MenuItem>
                  <MenuItem component={<Link to="/other-expenses" />}>
                    Other Expenses
                  </MenuItem>
                </SubMenu>
                <MenuItem
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      data-slot="icon"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 9.75v6.75m0 0-3-3m3 3 3-3m-8.25 6a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
                      />
                    </svg>
                  }
                  component={<Link to="/downloads" />}
                >
                  Downloads
                </MenuItem>

                <SubMenu
                  title="User Settings"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                      />
                    </svg>
                  }
                  label="User Settings"
                >
                  <MenuItem component={<Link to="/account-settings" />}>
                    User Management
                  </MenuItem>
                  <MenuItem>Logout</MenuItem>
                </SubMenu>
              </Menu>
            </Menu>
          </Sidebar>
          <main className="inner">
            {" "}
            {children}
            <div className="clear-both"></div>
          </main>
        </div>
      </div>
    </>
  );
}

export default StaticCustomSideBar;
